/* ============================================================
   WorldMultipleChoiceAB_FrontBlank.jsx
   ============================================================ */

export default function WorldMultipleChoiceAB_FrontBlank({
  value = {},
  onChange,
  items,
  mode = "edit",
  image = null,
  feedback
}) {
  console.log(feedback);
  function setAnswer(id, v) {
    if (mode !== "edit") return;
    //const letter = v.toUpperCase().replace(/[^AB]/g, "");
    const letter = v.toUpperCase().replace(/[^ABC]/g, "");
    onChange({
      ...value,
      [id]: letter
    });
  }

  const isReview = mode === "review";

  return (
    <div style={{ display: "grid", gap: 20 }}>
      {/* ───────────── QUESTIONS ───────────── */}
      <div style={{ display: "grid", gap: 14 }}>
        {items.map((q, i) => {
          const fb = feedback?.parts?.[q.id];

          const border =
            !isReview
              ? "1px solid #333"
              : fb?.correct
              ? "2px solid #2e7d32"
              : "2px solid #c62828";

          return (
            <div key={q.id} style={{ lineHeight: 1.8 }}>
              <strong>{i + 1}.</strong>{" "}
              <input
                type="text"
                maxLength={1}
                value={value[q.id] || ""}
                disabled={isReview}
                onChange={(e) => setAnswer(q.id, e.target.value)}
                style={{
                  width: 28,
                  height: 28,
                  textAlign: "center",
                  marginRight: 8,
                  border,
                  borderRadius: 4
                }}
              />

              {q.prefix && <span>{q.prefix} </span>}

              {/* <span style={{ fontWeight: "bold" }}>(A) {q.A} </span>
              <span style={{ fontWeight: "bold" }}>(B) {q.B} </span> 
              {q.text}*/}
              <span style={{ fontWeight: "bold" }}>(A) {q.A} </span>
              <span style={{ fontWeight: "bold" }}>(B) {q.B} </span>
              {q.C && (
                <span style={{ fontWeight: "bold" }}>(C) {q.C} </span>
              )}
              {q.text}

              {/* Optional expected answer
              {isReview && !fb?.correct && fb?.expected && (
                <div
                  style={{
                    fontSize: 12,
                    color: "#c62828",
                    marginLeft: 36
                  }}
                >
                  Correct answer: <strong>{fb.expected}</strong>
                </div>
              )} */}
            </div>
          );
        })}
      </div>

      {/* ───────────── OPTIONAL IMAGE ───────────── */}
      {image && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 12
          }}
        >
          <figure style={{ margin: 0, textAlign: "center" }}>
            <img
              src={image.src}
              alt={image.alt || ""}
              style={{
                maxWidth: image.maxWidth || "100%",
                objectFit: "contain",
                border: image.border ? "1px solid #ccc" : "none",
                borderRadius: 6
              }}
            />
            {image.caption && (
              <figcaption
                style={{
                  marginTop: 8,
                  fontSize: 13,
                  color: "#555"
                }}
              >
                {image.caption}
              </figcaption>
            )}
          </figure>
        </div>
      )}
    </div>
  );
}
